import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { addTags, hide, init, onDepartmentStatus, onChatStart, removeTags, selectDepartment, show } from "./api";
import { disableFormSettings, enableFormSettings, openFormDirectly } from "./apiForms";
import { getChatTags } from "./chatTag";
var apiReady = false;
var activeDepartmentName = null;
var activeUserRole;
var activeTags = null;
var autoSyncVisibility = true;
var syncedTags = null;
var departmentStatuses = new Map();
var formEnabled = false;
var formEmail = null;
var formApplicationId = null;
function handleDepartmentStatus(apiDepartment) {
  departmentStatuses.set(apiDepartment.name, apiDepartment.status);
  syncVisibility();
}

// this is used when the user initiates the first chat message
// need to set the tag for this page and possibly some url ids
export function handleChatStart() {
  // it is possible for multiple tabs to be open each
  // so just check the tab that is visible
  if (document.visibilityState === 'visible') {
    var fullURL = new URL(document.URL);
    var pathURL = fullURL.href.replace(fullURL.origin, '');
    var tags = getChatTags(pathURL);
    addTags(tags);
  }
}
function handleReady() {
  apiReady = true;
  onDepartmentStatus(handleDepartmentStatus);
  syncAll();
}
function initApiThenSyncAll(activeUserRole, options) {
  init(function () {
    handleReady();
  }, activeUserRole, options);
}
function isOnline(departmentName) {
  return departmentStatuses.get(departmentName) === 'online';
}
function syncSelectedDepartment() {
  selectDepartment(activeDepartmentName);
}
function syncVisibility() {
  if (!autoSyncVisibility) {
    return;
  }
  if (isOnline(activeDepartmentName) || formEnabled) {
    show();
  } else {
    hide();
  }
}
function syncTags() {
  if (syncedTags !== null) {
    removeTags(syncedTags);
    syncedTags = null;
  }
  if (activeTags !== null) {
    addTags(activeTags);
    syncedTags = activeTags;
  }
}
function syncForms() {
  if (formEnabled) {
    enableFormSettings({
      email: formEmail,
      applicationId: formApplicationId
    });
    show();
  }
}
function syncAll() {
  syncTags();
  syncSelectedDepartment();
  syncVisibility();
  syncForms();
  onChatStart(handleChatStart);
}

// Start to showing/hiding the widget based on the "online" status of the department
export function activate(departmentName, userRole) {
  var _additionalOptions$au;
  var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var additionalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  activeDepartmentName = departmentName;
  activeTags = tags;
  activeUserRole = userRole;
  autoSyncVisibility = (_additionalOptions$au = additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.autoSyncVisibility) !== null && _additionalOptions$au !== void 0 ? _additionalOptions$au : true;
  if (apiReady) {
    var _additionalOptions$on;
    syncAll();
    (_additionalOptions$on = additionalOptions.onReady) === null || _additionalOptions$on === void 0 ? void 0 : _additionalOptions$on.call(additionalOptions);
  } else {
    initApiThenSyncAll(activeUserRole, additionalOptions);
  }
}
export function deactivate() {
  activeDepartmentName = null;
  activeTags = null;
  if (apiReady) {
    hide();
  }
}
export function activateForms(_ref) {
  var _ref$email = _ref.email,
    email = _ref$email === void 0 ? null : _ref$email,
    _ref$applicationId = _ref.applicationId,
    applicationId = _ref$applicationId === void 0 ? null : _ref$applicationId;
  formEnabled = true;
  formEmail = email;
  formApplicationId = applicationId;
  if (apiReady) {
    enableFormSettings({
      email: formEmail,
      applicationId: formApplicationId
    });
    show();
  } else {
    initApiThenSyncAll(activeUserRole);
  }
}
export function deactivateForms() {
  formEnabled = false;
  formEmail = null;
  formApplicationId = null;
  if (apiReady) {
    disableFormSettings();
  }
}
export function openForm() {
  if (apiReady) {
    openFormDirectly();
  }
}
export function resetForTesting() {
  apiReady = false;
  activeDepartmentName = null;
  activeTags = null;
  syncedTags = null;
  departmentStatuses = new Map();
}